import { AirplaneLandingIcon } from './AirplaneLandingIcon';

/**
 * author: Google
 * id 634EE7E8-8280-4CF1-B642-0921E740B6DB
 * name airplane-landing
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-landing.svg
 * tags
 * - Transportation + Flying 
 */
export const FlightLandIcon = AirplaneLandingIcon;
export default FlightLandIcon